/**
 * Echoes of the Machine Theme - Main JavaScript
 */

(function() {
    'use strict';

    // Mobile menu toggle
    const burger = document.querySelector('.gh-burger');
    const body = document.body;

    if (burger) {
        burger.addEventListener('click', function() {
            body.classList.toggle('gh-head-open');
        });
    }

    // Close mobile menu when clicking outside
    document.addEventListener('click', function(event) {
        if (body.classList.contains('gh-head-open')) {
            if (!event.target.closest('.gh-head')) {
                body.classList.remove('gh-head-open');
            }
        }
    });

    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const href = this.getAttribute('href');
            if (href !== '#' && href.length > 1) {
                const target = document.querySelector(href);
                if (target) {
                    e.preventDefault();
                    target.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }
        });
    });

    // Add fade-in animation for post cards
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, observerOptions);

    // Observe post cards
    document.querySelectorAll('.post-card').forEach(card => {
        card.style.opacity = '0';
        card.style.transform = 'translateY(20px)';
        card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(card);
    });

    // #region agent log - Image loading and URL debug
    // Instrumentation to debug image loading and URL issues
    // HYPOTHESIS A: Browser is caching images based on domain/path, ignoring query params
    // HYPOTHESIS B: JavaScript URL decoder is corrupting URLs
    // HYPOTHESIS C: Template is rendering wrong feature_image for each post
    // HYPOTHESIS D: Browser is loading same image due to service worker or HTTP cache
    // HYPOTHESIS E: Pollinations.ai is returning same image despite different URLs
    
    const imageUrls = new Set();
    const imageLoadTimes = {};
    const imageData = [];
    
    // Log BEFORE any processing
    document.querySelectorAll('img.post-card-image').forEach((img, index) => {
        const rawSrc = img.getAttribute('src');
        const postUrl = img.dataset.postUrl || 'N/A';
        const postTitle = img.dataset.postTitle || 'N/A';
        
        imageData.push({
            index,
            rawSrc,
            postUrl,
            postTitle,
            elementId: img.id || `img-${index}`
        });
        
        fetch('http://127.0.0.1:7242/ingest/aee3bfbf-c7d7-4770-b7b9-35f5de823799', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                location: 'main.js:70',
                message: 'Image BEFORE processing',
                data: {
                    index,
                    rawSrc: rawSrc ? rawSrc.substring(0, 200) : 'NULL',
                    postUrl,
                    postTitle: postTitle.substring(0, 60),
                    hasAmp: rawSrc ? rawSrc.includes('&amp;') : false,
                    hasHex: rawSrc ? rawSrc.includes('&#x3D;') : false
                },
                timestamp: Date.now(),
                sessionId: 'debug-session',
                runId: 'run1',
                hypothesisId: 'C'
            })
        }).catch(() => {});
    });
    
    // Fix HTML-encoded URLs in image src attributes
    document.querySelectorAll('img.post-card-image').forEach((img, index) => {
        const currentSrc = img.getAttribute('src');
        if (currentSrc && (currentSrc.includes('&amp;') || currentSrc.includes('&#x3D;'))) {
            // Decode HTML entities
            const decodedSrc = currentSrc
                .replace(/&amp;/g, '&')
                .replace(/&#x3D;/g, '=')
                .replace(/&#39;/g, "'")
                .replace(/&quot;/g, '"');
            
            fetch('http://127.0.0.1:7242/ingest/aee3bfbf-c7d7-4770-b7b9-35f5de823799', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    location: 'main.js:95',
                    message: 'URL decoding applied',
                    data: {
                        index,
                        before: currentSrc.substring(0, 150),
                        after: decodedSrc.substring(0, 150),
                        changed: currentSrc !== decodedSrc
                    },
                    timestamp: Date.now(),
                    sessionId: 'debug-session',
                    runId: 'run1',
                    hypothesisId: 'B'
                })
            }).catch(() => {});
            
            img.src = decodedSrc;
        }
    });
    
    // Log AFTER processing and track loading
    document.querySelectorAll('img.post-card-image').forEach((img, index) => {
        const finalSrc = img.src; // This will be the decoded URL after fix above
        const postUrl = img.dataset.postUrl || 'N/A';
        const postTitle = img.dataset.postTitle || 'N/A';
        const loadStartTime = Date.now();
        
        // Track unique URLs
        imageUrls.add(finalSrc);
        
        fetch('http://127.0.0.1:7242/ingest/aee3bfbf-c7d7-4770-b7b9-35f5de823799', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                location: 'main.js:125',
                message: 'Image AFTER processing',
                data: {
                    index, 
                    finalSrc: finalSrc.substring(0, 200), 
                    postUrl, 
                    postTitle: postTitle.substring(0, 60),
                    totalImages: document.querySelectorAll('img.post-card-image').length,
                    uniqueUrlsSoFar: imageUrls.size,
                    urlHash: finalSrc.substring(0, 50) + '...' + finalSrc.substring(finalSrc.length - 30)
                },
                timestamp: Date.now(),
                sessionId: 'debug-session',
                runId: 'run1',
                hypothesisId: 'A'
            })
        }).catch(() => {});
        
        img.addEventListener('load', () => {
            const loadTime = Date.now() - loadStartTime;
            imageLoadTimes[finalSrc] = loadTime;
            
            // Check if image is actually different by sampling pixels
            const imgElement = img;
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = 10;
            canvas.height = 10;
            ctx.drawImage(imgElement, 0, 0, 10, 10);
            const imageData = ctx.getImageData(0, 0, 10, 10);
            const pixelHash = Array.from(imageData.data).slice(0, 20).join(',');
            
            fetch('http://127.0.0.1:7242/ingest/aee3bfbf-c7d7-4770-b7b9-35f5de823799', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    location: 'main.js:181',
                    message: 'Image loaded successfully',
                    data: {
                        index, 
                        src: finalSrc.substring(0, 200), 
                        postUrl,
                        postTitle: postTitle.substring(0, 60),
                        loadTimeMs: loadTime,
                        naturalWidth: img.naturalWidth,
                        naturalHeight: img.naturalHeight,
                        complete: img.complete,
                        pixelHash: pixelHash.substring(0, 50)
                    },
                    timestamp: Date.now(),
                    sessionId: 'debug-session',
                    runId: 'run1',
                    hypothesisId: 'D'
                })
            }).catch(() => {});
        });
        
        img.addEventListener('error', (e) => {
            const loadTime = Date.now() - loadStartTime;
            
            fetch('http://127.0.0.1:7242/ingest/aee3bfbf-c7d7-4770-b7b9-35f5de823799', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    location: 'main.js:208',
                    message: 'Image failed to load',
                    data: {
                        index, 
                        src: finalSrc.substring(0, 200), 
                        postUrl,
                        postTitle: postTitle.substring(0, 60),
                        error: e.type,
                        loadTimeMs: loadTime
                    },
                    timestamp: Date.now(),
                    sessionId: 'debug-session',
                    runId: 'run1',
                    hypothesisId: 'D'
                })
            }).catch(() => {});
        });
    });
    
    // Log summary after a delay
    setTimeout(() => {
        fetch('http://127.0.0.1:7242/ingest/aee3bfbf-c7d7-4770-b7b9-35f5de823799', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                location: 'main.js:140',
                message: 'Image loading summary',
                data: {
                    totalImages: document.querySelectorAll('img.post-card-image').length,
                    uniqueUrls: imageUrls.size,
                    loadedCount: Object.keys(imageLoadTimes).length,
                    avgLoadTime: Object.values(imageLoadTimes).length > 0 
                        ? Math.round(Object.values(imageLoadTimes).reduce((a, b) => a + b, 0) / Object.values(imageLoadTimes).length)
                        : 0,
                    allUrls: Array.from(imageUrls).map(u => u.substring(0, 100))
                },
                timestamp: Date.now(),
                sessionId: 'debug-session',
                runId: 'run1',
                hypothesisId: 'D'
            })
        }).catch(() => {});
    }, 5000);
    
    // Log article links
    document.querySelectorAll('a.post-card-title, a.post-card-image-link').forEach((link, index) => {
        fetch('http://127.0.0.1:7242/ingest/aee3bfbf-c7d7-4770-b7b9-35f5de823799', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                location: 'main.js:120',
                message: 'Article link found',
                data: {index, href: link.href, text: link.textContent.substring(0, 50)},
                timestamp: Date.now(),
                sessionId: 'debug-session',
                runId: 'run1',
                hypothesisId: 'C'
            })
        }).catch(() => {});
    });
    // #endregion

})();









